import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useAddManufactureDeviceMutation } from "../../../../redux/api/mod-bus/modBusAPI";
import { IHttpError } from "../../../../shared/oversight-core/interfaces/http-errror";
import AppInput from "../../../../shared/oversight-core/ui-elements/input/app-input";
import ModalContainer, {
  ModelContainerProps,
} from "../../../../shared/oversight-core/ui-elements/modal-container/modal-container";
import { NoWhitespaceRegex } from "../../../../shared/oversight-core/utils/regex";
import {
  showErrorMessage,
  showSuccessMessage,
} from "../../../../shared/oversight-core/utils/toast";

interface IFormInput {
  deviceId: string;
}

const defaultFormValues: IFormInput = {
  deviceId: "",
};

interface IProps extends ModelContainerProps {
  closeAddManufacturedDeviceModal: () => void;
}

const AddManufacturedDeviceModal = (props: IProps) => {
  const { ...rest } = props;

  const [addManufactureDevice, { isLoading, isSuccess }] =
    useAddManufactureDeviceMutation();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<IFormInput>({
    defaultValues: { ...defaultFormValues },
  });

  useEffect(() => {
    if (isSuccess) {
      showSuccessMessage("Device added successfully");
      reset({ ...defaultFormValues });
      props.closeAddManufacturedDeviceModal();
    }
  }, [isSuccess]);

  const onSubmit = (data: IFormInput) => {
    addManufactureDevice({
      deviceId: data.deviceId.trim(),
    })
      .unwrap()
      .catch((error: IHttpError) => {
        showErrorMessage(error.message || "Adding device unsuccessful");
      });
  };

  return (
    <ModalContainer
      {...rest}
      title="Add Device"
      size="modal-lg"
      onConfirm={handleSubmit(onSubmit)}
      onCancel={() => {
        reset({ ...defaultFormValues });
        if (props.onCancel) {
          props.onCancel();
        }
      }}
      onClose={() => {
        reset({ ...defaultFormValues });
        if (props.onClose) {
          props.onClose();
        }
      }}
      isLoading={isLoading}
    >
      <>
        <AppInput
          label="Device ID"
          placeholder="Device ID"
          name="deviceId"
          type="text"
          register={register("deviceId", {
            required: "Device ID is required",
            pattern: {
              value: NoWhitespaceRegex,
              message: "Spaces are not allowed.",
            },
          })}
          errors={errors}
        />
      </>
    </ModalContainer>
  );
};

export default AddManufacturedDeviceModal;
